"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactVirtualized = require("react-virtualized");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hooks = require("@nicbase/hooks");

var _ColumnRenderer = _interopRequireDefault(require("./ColumnRenderer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var RowRenderer = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var className = _ref.className,
      columns = _ref.columns,
      parent = _ref.parent,
      index = _ref.index,
      cellCache = _ref.cellCache,
      rowData = _ref.rowData,
      isScrolling = _ref.isScrolling,
      isSelected = _ref.isSelected,
      onRowClick = _ref.onRowClick,
      onRowDoubleClick = _ref.onRowDoubleClick,
      onRowMouseOut = _ref.onRowMouseOut,
      onRowMouseOver = _ref.onRowMouseOver,
      onRowFocus = _ref.onRowFocus,
      onRowBlur = _ref.onRowBlur,
      style = _ref.style;
  var updateRowSize = (0, _react.useCallback)(function () {
    cellCache.clear(index);
    parent.recomputeGridSize({
      rowIndex: index
    });
  }, [cellCache, index, parent]);
  var prevColumns = (0, _hooks.usePrevious)(columns);
  var prevRowData = (0, _hooks.usePrevious)(rowData); // update row size if the columns have changed

  (0, _hooks.useDidUpdate)(function () {
    if (prevColumns !== columns || prevRowData !== rowData) {
      updateRowSize();
    }
  }, [columns, prevColumns, prevRowData, rowData, updateRowSize]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    role: "row",
    tabIndex: 0,
    onClick: function onClick() {
      return onRowClick({
        index: index,
        rowData: rowData
      });
    },
    onDoubleClick: function onDoubleClick() {
      return onRowDoubleClick({
        index: index,
        rowData: rowData
      });
    },
    onMouseOut: function onMouseOut() {
      return onRowMouseOut({
        index: index,
        rowData: rowData
      });
    },
    onMouseOver: function onMouseOver() {
      return onRowMouseOver({
        index: index,
        rowData: rowData
      });
    },
    onFocus: function onFocus() {
      return onRowFocus({
        index: index,
        rowData: rowData
      });
    },
    onBlur: function onBlur() {
      return onRowBlur({
        index: index,
        rowData: rowData
      });
    },
    style: style,
    className: className,
    key: index
  }, columns.map(function (column, columnIndex) {
    return /*#__PURE__*/_react["default"].createElement(_ColumnRenderer["default"], {
      key: column.props.dataKey,
      cellCache: cellCache,
      column: column,
      columnIndex: columnIndex,
      rowIndex: index,
      rowData: rowData,
      parent: parent,
      scrollbarWidth: style.scrollbarWidth,
      isScrolling: isScrolling,
      isSelected: isSelected
    });
  }));
});

RowRenderer.propTypes = {
  className: _propTypes["default"].string,
  columns: _propTypes["default"].arrayOf(_propTypes["default"].element).isRequired,
  isScrolling: _propTypes["default"].bool,
  parent: _propTypes["default"].instanceOf(_reactVirtualized.Grid),
  index: _propTypes["default"].number.isRequired,
  rowData: _propTypes["default"].shape({}).isRequired,
  onRowClick: _propTypes["default"].func,
  onRowDoubleClick: _propTypes["default"].func,
  onRowMouseOut: _propTypes["default"].func,
  onRowMouseOver: _propTypes["default"].func,
  onRowFocus: _propTypes["default"].func,
  onRowBlur: _propTypes["default"].func,
  cellCache: _propTypes["default"].instanceOf(_reactVirtualized.CellMeasurerCache),
  style: _propTypes["default"].shape({
    scrollbarWidth: _propTypes["default"].number
  }),
  isSelected: _propTypes["default"].bool
};

var noop = function noop() {};

RowRenderer.defaultProps = {
  cellCache: null,
  className: 'nic-table-row',
  style: {},
  isScrolling: false,
  isSelected: false,
  parent: null,
  onRowClick: noop,
  onRowDoubleClick: noop,
  onRowMouseOut: noop,
  onRowMouseOver: noop,
  onRowFocus: noop,
  onRowBlur: noop
};
var _default = RowRenderer;
exports["default"] = _default;